import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20609f18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid gap-3 grid-cols-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-semibold mt-3" }, "Укажите город отправления и пункт прибытия", -1))
const _hoisted_3 = { class: "grid gap-3 grid-cols-2 mt-2" }
const _hoisted_4 = {
  key: 0,
  class: "mt-1 flex flex-col items-center justify-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-red-400 text-sm" }, "При загрузке направления произошла ошибка", -1))
const _hoisted_6 = { class: "grid grid-cols-2 gap-3 mt-2" }
const _hoisted_7 = { class: "CalculatorForm__place" }
const _hoisted_8 = { class: "font-semibold mt-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_10 = { class: "flex items-center justify-end mt-4" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-semibold mt-3" }, "Выберите способ доставки", -1))
const _hoisted_13 = { class: "grid gap-3 grid-cols-3 mt-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-semibold mt-3" }, "Дополнительные услуги", -1))
const _hoisted_15 = { class: "grid gap-3 grid-cols-3 items-center mt-4" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-semibold" }, "Мягкая упаковка", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-semibold" }, "Паллета", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-semibold" }, "Обрешетка", -1))
const _hoisted_19 = { class: "grid gap-3 grid-cols-4 items-start mt-4" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-semibold" }, "Манипулятор", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-semibold" }, "Кран", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-semibold" }, "Грузчики", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-semibold" }, "Рохля", -1))
const _hoisted_24 = { class: "flex items-center justify-between mt-4" }
const _hoisted_25 = {
  key: 0,
  class: "text-red-400 text-sm"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calculator mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_checkbox = _resolveComponent("checkbox")!

  return (_openBlock(), _createElementBlock("form", {
    class: "CalculatorForm",
    onSubmit: _cache[23] || (_cache[23] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmitForm && _ctx.onSubmitForm(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_the_select, {
        placeholder: "Тариф",
        disabled: _ctx.loading || _ctx.direction_state.is_loading,
        options: _ctx.TARIFFS,
        searchable: false,
        value: _ctx.state.tariff_id,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.tariff_id) = $event)),
        onChange: _ctx.onTypeChange
      }, null, 8, ["disabled", "options", "value", "onChange"]),
      (_ctx.state.tariff_id !== 1)
        ? (_openBlock(), _createBlock(_component_the_select, {
            key: 0,
            placeholder: "Компания",
            "can-deselect": "",
            disabled: _ctx.loading || _ctx.direction_state.is_loading || Boolean(_ctx.state.weight),
            loading: _ctx.data_state.companies.is_loading || _ctx.direction_state.is_loading,
            failed: _ctx.data_state.companies.is_failed,
            "error-text": "При получении списка компаний отправлений произошла ошибка",
            options: _ctx.data_state.companies.list,
            value: _ctx.state.company_id,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.company_id) = $event)),
            "search-without-refresh": "",
            label: "short_name",
            onRefresh: _ctx.loadCompanies,
            onChange: _ctx.onCompanySelect
          }, null, 8, ["disabled", "loading", "failed", "options", "value", "onRefresh", "onChange"]))
        : _createCommentVNode("", true),
      (_ctx.state.tariff_id === 7)
        ? (_openBlock(), _createBlock(_component_the_select, {
            key: 1,
            placeholder: "Вес",
            "can-deselect": "",
            disabled: _ctx.loading || Boolean(_ctx.state.company_id),
            options: _ctx.WEIGHTS,
            searchable: false,
            loading: _ctx.amount_state.is_loading,
            value: _ctx.state.weight,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.weight) = $event))
          }, null, 8, ["disabled", "options", "loading", "value"]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_the_select, {
        placeholder: "Город отправления",
        disabled: _ctx.loading || _ctx.direction_state.is_loading,
        loading: _ctx.data_state.from_cities.is_loading || _ctx.direction_state.is_loading,
        failed: _ctx.data_state.from_cities.is_failed,
        "error-text": "При получении списка городов отправлений произошла ошибка",
        options: _ctx.data_state.from_cities.list,
        "is-invalid": _ctx.state_form$.from_city.$error,
        "validation-errors": _ctx.state_form$.from_city.$errors,
        value: _ctx.state.from_city_id,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.from_city_id) = $event)),
        "search-without-refresh": "",
        onRefresh: _ctx.loadFromCities,
        onChange: _ctx.onFromCityChange
      }, null, 8, ["disabled", "loading", "failed", "options", "is-invalid", "validation-errors", "value", "onRefresh", "onChange"]),
      _createVNode(_component_the_select, {
        placeholder: "Пункт прибытия",
        disabled: _ctx.loading || _ctx.direction_state.is_loading,
        loading: _ctx.data_state.where_cities.is_loading || _ctx.direction_state.is_loading,
        failed: _ctx.data_state.where_cities.is_failed,
        "error-text": "При получении списка городов прибытий произошла ошибка",
        options: _ctx.data_state.where_cities.list,
        "is-invalid": _ctx.state_form$.where_city.$error,
        "validation-errors": _ctx.state_form$.where_city.$errors,
        value: _ctx.state.where_city_id,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.where_city_id) = $event)),
        "search-without-refresh": "",
        onRefresh: _ctx.loadWhereCities,
        onChange: _ctx.onWhereCityChange
      }, null, 8, ["disabled", "loading", "failed", "options", "is-invalid", "validation-errors", "value", "onRefresh", "onChange"])
    ]),
    (_ctx.direction_state.is_failed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_the_button, {
            class: "primary small mt-1",
            onClick: _ctx.loadDirection
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Перезагрузить ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_the_input, {
        placeholder: "Объявленная стоимость",
        value: _ctx.state.declaredPrice,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.declaredPrice) = $event)),
        "is-invalid": _ctx.state_form$.declaredPrice.$error,
        "validation-errors": _ctx.state_form$.declaredPrice.$errors
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        placeholder: "Наименование товара",
        value: _ctx.state.productName,
        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.productName) = $event))
      }, null, 8, ["value"])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.volumeWeight, (volume_weight, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "mt-3",
        key: `volumeWeight-${i}`
      }, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, "Место #" + _toDisplayString(i + 1), 1),
          _createVNode(_component_the_input, {
            placeholder: "Вес отправления (кг)",
            disabled: _ctx.loading,
            value: _ctx.state.physicalWeights[i].weight,
            "onUpdate:value": ($event: any) => ((_ctx.state.physicalWeights[i].weight) = $event)
          }, null, 8, ["disabled", "value", "onUpdate:value"]),
          _createVNode(_component_the_input, {
            placeholder: "Длина отправления (см)",
            disabled: _ctx.loading,
            value: _ctx.state.volumeWeight[i].length,
            "onUpdate:value": ($event: any) => ((_ctx.state.volumeWeight[i].length) = $event)
          }, null, 8, ["disabled", "value", "onUpdate:value"]),
          _createVNode(_component_the_input, {
            placeholder: "Ширина отправления (см)",
            disabled: _ctx.loading,
            value: _ctx.state.volumeWeight[i].width,
            "onUpdate:value": ($event: any) => ((_ctx.state.volumeWeight[i].width) = $event)
          }, null, 8, ["disabled", "value", "onUpdate:value"]),
          _createVNode(_component_the_input, {
            placeholder: "Высота отправления (см)",
            disabled: _ctx.loading,
            value: _ctx.state.volumeWeight[i].height,
            "onUpdate:value": ($event: any) => ((_ctx.state.volumeWeight[i].height) = $event)
          }, null, 8, ["disabled", "value", "onUpdate:value"]),
          (_ctx.state.volumeWeight.length > 1)
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 0,
                class: "red small mt-2",
                onClick: ($event: any) => (_ctx.removePlace(i))
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_the_button, {
        class: "small primary",
        onClick: _ctx.addPlace
      }, {
        default: _withCtx(() => [
          _hoisted_11,
          _createTextVNode(" Добавить место ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _hoisted_12,
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_checkbox, {
        label: "Самовывоз",
        value: _ctx.state.is_has_pickup,
        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.is_has_pickup) = $event)),
        disabled: _ctx.loading
      }, null, 8, ["value", "disabled"]),
      _createVNode(_component_checkbox, {
        label: "Самопривоз",
        value: _ctx.state.is_has_self_delivery,
        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.is_has_self_delivery) = $event)),
        disabled: _ctx.loading
      }, null, 8, ["value", "disabled"]),
      _createVNode(_component_checkbox, {
        label: "Сбор за оформление заказа",
        value: _ctx.state.isOrderPrice,
        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.isOrderPrice) = $event)),
        disabled: _ctx.loading
      }, null, 8, ["value", "disabled"])
    ]),
    _hoisted_14,
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", null, [
        _hoisted_16,
        _createVNode(_component_the_input, {
          class: "mt-1",
          placeholder: "Куб. метры",
          value: _ctx.state.additional_services.soft_package_value,
          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.additional_services.soft_package_value) = $event)),
          "is-invalid": _ctx.state_form$.additional_services.soft_package_value.$error,
          "validation-errors": _ctx.state_form$.additional_services.soft_package_value.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_17,
        _createVNode(_component_the_input, {
          class: "mt-1",
          placeholder: "Куб. метры",
          value: _ctx.state.additional_services.pallet_value,
          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.additional_services.pallet_value) = $event)),
          "is-invalid": _ctx.state_form$.additional_services.pallet_value.$error,
          "validation-errors": _ctx.state_form$.additional_services.pallet_value.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_18,
        _createVNode(_component_the_input, {
          class: "mt-1",
          placeholder: "Куб. метры",
          value: _ctx.state.additional_services.grid_value,
          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.additional_services.grid_value) = $event)),
          "is-invalid": _ctx.state_form$.additional_services.grid_value.$error,
          "validation-errors": _ctx.state_form$.additional_services.grid_value.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", null, [
        _hoisted_20,
        _createVNode(_component_the_input, {
          class: "mt-1",
          placeholder: "Количество",
          value: _ctx.state.additional_services.manipulator_value,
          "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.additional_services.manipulator_value) = $event)),
          "is-invalid": _ctx.state_form$.additional_services.manipulator_value.$error,
          "validation-errors": _ctx.state_form$.additional_services.manipulator_value.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          class: "mt-2",
          placeholder: "Отработанные часы",
          value: _ctx.state.additional_services.manipulator_duration,
          "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.additional_services.manipulator_duration) = $event)),
          "is-invalid": _ctx.state_form$.additional_services.manipulator_duration.$error,
          "validation-errors": 
                        _ctx.state_form$.additional_services.manipulator_duration.$errors
                    
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          class: "mt-2",
          placeholder: "Себестоимость за час",
          value: _ctx.state.additional_services.manipulator_costPerHour,
          "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.additional_services.manipulator_costPerHour) = $event)),
          "is-invalid": _ctx.state_form$.additional_services.manipulator_costPerHour.$error,
          "validation-errors": 
                        _ctx.state_form$.additional_services.manipulator_costPerHour.$errors
                    
        }, null, 8, ["value", "is-invalid", "validation-errors"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_21,
        _createVNode(_component_the_input, {
          class: "mt-1",
          placeholder: "Количество",
          value: _ctx.state.additional_services.crane_value,
          "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.additional_services.crane_value) = $event)),
          "is-invalid": _ctx.state_form$.additional_services.crane_value.$error,
          "validation-errors": _ctx.state_form$.additional_services.crane_value.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          class: "mt-2",
          placeholder: "Отработанные часы",
          value: _ctx.state.additional_services.crane_duration,
          "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.additional_services.crane_duration) = $event)),
          "is-invalid": _ctx.state_form$.additional_services.crane_duration.$error,
          "validation-errors": _ctx.state_form$.additional_services.crane_duration.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          class: "mt-2",
          placeholder: "Себестоимость за час",
          value: _ctx.state.additional_services.crane_costPerHour,
          "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.additional_services.crane_costPerHour) = $event)),
          "is-invalid": _ctx.state_form$.additional_services.crane_costPerHour.$error,
          "validation-errors": _ctx.state_form$.additional_services.crane_costPerHour.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_22,
        _createVNode(_component_the_input, {
          class: "mt-1",
          placeholder: "Количество",
          value: _ctx.state.additional_services.loader_value,
          "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.additional_services.loader_value) = $event)),
          "is-invalid": _ctx.state_form$.additional_services.loader_value.$error,
          "validation-errors": _ctx.state_form$.additional_services.loader_value.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          class: "mt-2",
          placeholder: "Отработанные часы",
          value: _ctx.state.additional_services.loader_duration,
          "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.additional_services.loader_duration) = $event)),
          "is-invalid": _ctx.state_form$.additional_services.loader_duration.$error,
          "validation-errors": _ctx.state_form$.additional_services.loader_duration.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_23,
        _createVNode(_component_the_input, {
          class: "mt-1",
          placeholder: "Количество",
          value: _ctx.state.additional_services.hydraulic_trolley_value,
          "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.additional_services.hydraulic_trolley_value) = $event)),
          "is-invalid": _ctx.state_form$.additional_services.hydraulic_trolley_value.$error,
          "validation-errors": 
                        _ctx.state_form$.additional_services.hydraulic_trolley_value.$errors
                    
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          class: "mt-2",
          placeholder: "Отработанные часы",
          value: _ctx.state.additional_services.hydraulic_trolley_duration,
          "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.additional_services.hydraulic_trolley_duration) = $event)),
          "is-invalid": _ctx.state_form$.additional_services.hydraulic_trolley_duration.$error,
          "validation-errors": 
                        _ctx.state_form$.additional_services.hydraulic_trolley_duration.$errors
                    
        }, null, 8, ["value", "is-invalid", "validation-errors"])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", null, [
        (_ctx.isDirectionMissing)
          ? (_openBlock(), _createElementBlock("span", _hoisted_25, " По выбранным городам не найдено активное направление "))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_the_button, {
        class: "primary small",
        type: "submit",
        disabled: _ctx.isDirectionMissing,
        loading: _ctx.loading
      }, {
        default: _withCtx(() => [
          _hoisted_26,
          _createTextVNode(" Рассчитать стоимость ")
        ]),
        _: 1
      }, 8, ["disabled", "loading"])
    ])
  ], 32))
}